module.exports = __webpack_public_path__ + "static/img/writeImg.c5a52681.png";